import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map,tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { environment } from "src/environments/environment";

@Injectable({providedIn: 'root'})
export class FvmsApiBaseService {
    header = new HttpHeaders({
        "Content-Type":"application/json"
    });
    
    constructor(
        public http:HttpClient
    ) {

    }

    getApiBaseUrl(){
        let url = environment.api.protocol;
        url += "://";
        url += environment.api.host;
        url += ":";
        url += environment.api.port;
        return url;
    }
}
